<script>
import { createNamespacedHelpers } from 'vuex';
import Cookies from 'js-cookie';

import { WECHAT_GRANT } from '@/store/wechat/types';
import { ROUTE_COURSE_HOME } from '@/router/names';

const { mapActions } = createNamespacedHelpers('wechat');

export default {
    async created() {
        const { code } = this.$route.query;
        await this.wechatGrant({
            code,
        });
        const redirect = Cookies.get('redirect');
        if (redirect) {
            Cookies.remove('redirect');
            this.$router.replace(redirect);
        } else {
            this.$route.replace({ name: ROUTE_COURSE_HOME });
        }
    },
    methods: {
        ...mapActions({
            wechatGrant: WECHAT_GRANT,
        }),
    },
    render() {
        return null;
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/wechat/Callback.vue